import { clinicHasRequestedSpecialty } from 'pages/results/helpers/specialty-helpers';

export enum GtmDataLayerEvent {
  SearchQuestionWelcomeReached = 'questionWelcomeReached',
  SearchQuestionAttitudeReached = 'questionAttitudeReached',
  SearchQuestionInsuranceReached = 'questionInsuranceReached',
  SearchResultsReached = 'matchResultsReached',
  AppointmentCheckoutAccountCreated = 'appointmentCheckoutAccountCreated',
  AppointmentCheckoutAccountVerified = 'appointmentCheckoutAccountVerified',
  InsuranceInfoSubmitted = 'insuranceInfoSubmitted',
  AppointmentRequested = 'appointmentRequested',
  PatientInfoSubmitted = 'patientInfoSubmitted',
}

export const trackGtmDataLayerEvent = (
  eventName: GtmDataLayerEvent,
  variables: Record<string, string | number> = {},
) => {
  if (!eventName) {
    return;
  }

  window.dataLayer ||= [];
  window.dataLayer.push({
    event: eventName,
    ...variables,
  });
};

interface AnalyticsMatch {
  other?: {
    triageResponse?: string;
    specialistData?: {
      specialistTypes?: { id: string; }[];
      hasReferral?: boolean;
    };
  };
}

interface AnalyticsClinic {
  providers?: {
    specialties?: { id: string; }[];
  }[];
}

interface SpecialistAnalyticsData {
  did_select_specialty: string;
  selected_specialties: string;
  has_referral: string;
  num_results_with_matching_specialty?: string;
}

export const getSpecialistAnalyticsData = (match: AnalyticsMatch, results: AnalyticsClinic[]) => {
  const customProperties: SpecialistAnalyticsData = {
    did_select_specialty: String(match?.other?.triageResponse === 'specialist'),
    selected_specialties: String(
      match?.other?.specialistData?.specialistTypes?.map((s) => s.id).join(','),
    ),
    has_referral: String(match?.other?.specialistData?.hasReferral),
  };

  if (results?.length) {
    customProperties.num_results_with_matching_specialty = String(
      results.filter((clinic) => clinicHasRequestedSpecialty({ clinic, match }))
        .length,
    );
  }

  return customProperties;
};
